<template>
  <headerSearch></headerSearch>
  <div class="w1440 personal_center">
    <div class="flex-box col90 ptb10 page_location">
      当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
      <router-link class="col04" to="/BaseInfo">我的账户<span class="plr5">/</span></router-link>
      <div class="now_page">收货地址</div>
    </div>
    <div class="flex-box flex-col-start">
      <personal-nav :firstIndex="0" :secondIndex="2"></personal-nav>
      <div class="ml10 flex-grow-1 part_r">
        <div class="flex-box fs16">
          <div class="col04 flex-grow-1 fs18">我的地址</div>
          <div @click="bindCopy" class="flex-box mr45 copy col90 cursor">复制</div>
          <!-- <div @click="onDel" class="flex-box mr45 delete col12 cursor">删除</div> -->
          <!-- <div class="flex-box new colf flex-center cursor" @click="newAddPop = true">新 增</div> -->
        </div>
        <div class="list_box mt35">
          <div class="title_box flex-box col04 fs14">
            <div @click="pickall" :class="allpicked ? 'active' : ''" class="box1 cursor"></div>
            <div class="box2 tc">姓名</div>
            <div class="box3 tc">联系电话</div>
            <div class="flex-grow-1">详细地址</div>
          </div>
          <div class="address_box flex-box col90 fs14" v-for="(item, index) in addressList" :key="index"
            @click="tapInfo(item.id)">
            <div class="box1 cursor " :class="selectids.indexOf(item.id) != -1 ? 'active' : ''"></div>
            <div class="box2 tc">{{ item.consignee }}</div>
            <div class="box3 tc">{{ item.mobile }}</div>
            <div class="flex-grow-1 flex-box">
              <div>{{ item.province_name + item.city_name + item.district_name + item.address }}</div>
              <div v-if="item.is_default == 1" class="default fs10 colf tc ml5">默认</div>
            </div>
          </div>
        </div>
        <!-- <pagination :sumCount="20" :perCount="10"></pagination> -->
      </div>
    </div>
  </div>
  <popup :visible="newAddPop" @close="newAddPop = false">
    <div class="add_pop relative bgf br10">
      <div class="title_box">
        <img src="../../../assets/static/icon/c_pop_close.png" class="pop_close cursor" @click="newAddPop = false" alt="">
        <div class="title fs18 fwb mb25 col12 flex-box">新增地址<i class="add"></i></div>
        <div class="fs14 col12">请完善您的地址信息，以便我们更好地为您提供服务。</div>
      </div>
      <div class="form_box">
        <div class="flex-box flex-between mb25">
          <div>
            <div class="title must fs16 col04 relative mb15">姓名</div>
            <input v-model="address.consignee" type="text" class="input fs14" placeholder="请输入联系人">
          </div>
          <div>
            <div class="title must fs16 col04 relative mb15">手机号</div>
            <input v-model="address.mobile" type="text" class="input fs14" placeholder="请输入联系手机号">
          </div>
        </div>
        <div class="title fs16 col04 relative mb15">邮政编码</div>
        <input v-model="address.zip_code" type="text" class="input fs14 code mb25" placeholder="请输入您的邮编">
        <div class="title must fs16 col04 relative mb15">地址信息</div>
        <div class="flex-box flex-between mb15">
          <div class="select_box relative">
            <div class="flex-box select fs14 cursor" @click="showpro()">
              <div v-if="address.province_name" class="flex-grow-1 ">{{ address.province_name }}</div>
              <div v-else class="flex-grow-1 col90">所属省份</div>
            </div>
            <div class="data_list" :class="showProvince ? 'show' : ''">
              <div class="item fs14 cursor" v-for="(item, index) in areas" :key="index" @click="showpro(item, index)">
                {{ item.name }}</div>
            </div>
          </div>
          <div class="select_box relative">
            <div class="flex-box select fs14 cursor" @click="showcity()">
              <div v-if="address.city_name" class="flex-grow-1 ">{{ address.city_name }}</div>
              <div v-else class="flex-grow-1 col90">所属城市</div>
            </div>
            <div class="data_list" :class="showCity ? 'show' : ''">
              <div class="item fs14 cursor" v-for="(item, index) in city_list" :key="index" @click="showcity(item, index)">
                {{ item.name }}</div>
            </div>
          </div>
          <div class="select_box relative">
            <div class="flex-box select fs14 cursor" @click="showregion()">
              <div v-if="address.district_name" class="flex-grow-1 ">{{ address.district_name }}</div>
              <div v-else class="flex-grow-1 col90">所属区域</div>
            </div>
            <div class="data_list" :class="showArea ? 'show' : ''">
              <div class="item fs14 cursor" v-for="(item, index) in region_list" :key="index"
                @click="showregion(item, index)">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <textarea v-model="address.address" class="textarea fs14 mb25" placeholder="请输入您的详细地址，具体到**室**号"></textarea>
        <div class="flex-box flex-between cursor" @click="setDefault = !setDefault">
          <div class="fs14 col04">设为默认地址</div>
          <i class="default" :class="setDefault ? 'active' : ''"></i>
        </div>
        <div @click="save" class="cursor sure fs14 colf">确认</div>
      </div>
    </div>
  </popup>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
  setup() {
    onMounted(() => {
      useHead({
        title: "收货地址-小狮优选",
        meta: [
          { name: "description", content: "This is my page description" },
          { property: "og:title", content: "My Page Title" },
          { property: "og:description", content: "This is my page description" },
          { property: "og:url", content: "https://example.com/my-page" },
          { property: "og:image", content: "https://example.com/my-image.jpg" },
        ],
        link: [{ rel: "canonical", href: "https://example.com/my-page" }],
      })
    })
  },
  components: {
    PersonalNav,
  },
  data() {
    return {
      newAddPop: false,
      showProvince: false,
      showCity: false,
      showArea: false,
      setDefault: false,

      isBack: true,
      areas: [],
      city_list: [],
      region_list: [],
      addressList: [{}],
      selectids: [],

      popStatus: false,
      rule: [{
        name: 'consignee',
        nameChn: '收货人',
        rules: ['require'],
        errorMsg: {
          require: '请填写收货人'
        }
      },
      {
        name: 'mobile',
        nameChn: '手机号',
        rules: ['require', 'mobile'],
        errorMsg: {
          require: '请填写手机号',
          mobile: '请填写正确的手机号'
        }
      },
      {
        name: 'district_id',
        nameChn: '地区',
        rules: ['gt:0'],
        errorMsg: {
          require: '请选择地区'
        }
      },
      {
        name: 'address',
        nameChn: '详细地址',
        rules: ['require'],
        errorMsg: {
          require: '请填写详细地址'
        }
      },

      ],
      address: {
        consignee: '',
        province_id: 0,
        province_name: '',
        city_id: 0,
        city_name: '',
        district_id: 0,
        district_name: 0,
        mobile: '',
        address: '',
        is_default: false,
        region: '',
      }
    };
  },
  computed: {
    islogin() {
      return this.$h.islogin()
    },
    allpicked() {
      return this.selectids.length == this.addressList.length
    }
  },
  created() {
    if (!this.islogin) {
      this.$router.push('/Login')
    } else {
      const options = this.$route.query;
      if (options && options.is_back) {
        this.isBack = false;
      }
      this.start()
    }
  },
  methods: {
    save() {
      let address = this.address
      address.is_default = this.setDefault
      this.$api.AddressAdd(address).then(res => {
        if (res.code == 1) {
          this.$message({
            customClass: 'custom-message',
            message: res.msg,
            type: 'success'
          })
          this.newAddPop = false
          this.start()
        } else {
          this.$alert(res.msg)
        }
      })
    },
    showpro(item = '', index = 0) {
      if (item) {
        this.city_list = item.childlist
        this.address.province_id = item.id
        this.address.province_name = item.name
        this.address.city_id = 0
        this.address.city_name = ''
        this.address.district_id = 0
        this.address.district_name = ''
      }
      this.showProvince = !this.showProvince
      this.showCity = this.showArea = false
    },
    showcity(item = '', index = 0) {
      if (item) {
        this.region_list = item.childlist
        this.address.city_id = item.id
        this.address.city_name = item.name
        this.address.district_id = 0
        this.address.district_name = ''
      }
      this.showCity = !this.showCity
      this.showProvince = this.showArea = false
    },
    showregion(item = '', index = 0) {
      if (item) {
        this.address.district_id = item.id
        this.address.district_name = item.name
      }
      this.showArea = !this.showArea
      this.showProvince = this.showCity = false
    },
    start() {
      this.$api.Address().then(res => {
        this.addressList = res.data;
      })
      this.$api.getArea().then(res => {
        this.areas = res.data
      })
      this.address = {
        consignee: '',
        province_id: 0,
        province_name: '',
        city_id: 0,
        city_name: '',
        district_id: 0,
        district_name: 0,
        mobile: '',
        address: '',
        is_default: false,
        region: '',
      }
      this.setDefault = false
    },
    //选择地址
    onSelect(addressInfo) { },
    tapInfo(e) {
      if (this.selectids.indexOf(e) == -1) {
        console.log(e) //打印下标
        this.selectids.push(e); //选中添加到数组里
      } else {
        this.selectids.splice(this.selectids.indexOf(e), 1); //取消
      }
    },
    //全选
    pickall() {
      if (this.selectids.length == this.addressList.length) {
        this.selectids = [];
      } else {
        this.selectids = [];
        this.addressList.forEach(item => {
          this.selectids.push(item.id);
        })
      }
    },
    bindCopy() {
      let ids = this.selectids;
      let checkedAddress = [];
      if (ids.length <= 0) {
        // this.$alert("请选择复制地址")
        this.$message({
          customClass: 'custom-message',
          message: '请选择复制地址',
          type: 'warning'
        })
        return;
      }
      this.addressList.forEach(address => {
        if (ids.includes(address.id)) {
          let myaddress = address.province_name + address.city_name + address.district_name + address
            .address + " " + address.consignee + " " + address.mobile;
          checkedAddress.push(myaddress);
        }
      })
      const textToCopy = checkedAddress.join('\n');
      console.log(textToCopy)
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.$message({
            customClass: 'custom-message',
            message: '内容已复制',
            type: 'success'
          })
          // this.$alert('内容已复制');
        })
        .catch((error) => {
          this.$alert('复制失败');
          console.error('复制失败：', error);
        });
    },
    //删除
    onDel() {
      let page = this;
      let ids = this.selectids;
      if (ids.length <= 0) {
        this.$message({
          customClass: 'custom-message',
          message: '请选择要删除的地址',
          type: 'warning'
        });
        return;
      }
      this.$confirm('确认删除此收货地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.AddressDel({
          ids
        }).then(res => {
          this.$message({
            customClass: 'custom-message',
            type: 'success',
            message: '删除成功!'
          });
          this.start()
        })
      }).catch(() => {
        this.$message({
          customClass: 'custom-message',
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //添加
    onSave(e) {
      this.$core.checkValidate(this, e, this.rule, false).then(res => {
        this.$core.post({
          url: 'v1.user_address/add',
          data: e,
          success: (ret) => {
            uni.showToast({
              title: ret.msg,
              icon: 'none'
            });
            this.togglePopup({
              popStatus: false
            });
            this.fetch();
          },
          fail: (ret) => {
            uni.showModal({
              title: '提示',
              content: ret.msg
            })
            return false;
          }
        });
      })
    }
  },
};
</script>

<style lang="less" scoped>
.part_r {
  padding: 32px 44px 100px;
  background: #fff;

  .copy::before {
    display: block;
    content: "";
    width: 22px;
    height: 22px;
    display: block;
    margin-right: 12px;
    background: url('/src/assets/static/icon/c_add_copy.png') no-repeat center;
    background-size: 100%;
  }

  .delete::before {
    display: block;
    content: "";
    width: 20px;
    height: 22px;
    display: block;
    margin-right: 12px;
    background: url('/src/assets/static/icon/c_add_del.png') no-repeat center;
    background-size: 100%;
  }

  .new {
    width: 108px;
    height: 44px;
    border-radius: 6px;
    background: #1275ff;

    &::before {
      display: block;
      content: "";
      width: 18px;
      height: 18px;
      display: block;
      margin-right: 8px;
      background: url('/src/assets/static/icon/c_add_new.png') no-repeat center;
      background-size: 100%;
    }
  }

  .title_box {
    padding-left: 44px;
    height: 50px;
    background: #fafcff;
  }

  .address_box {
    padding-left: 44px;
    height: 68px;
    border-bottom: 1px solid #c0cfdd;
  }

  .box1 {
    width: 20px;
    height: 20px;
    background: url('/src/assets/static/icon/c_check.png') no-repeat center;
    background-size: 100%;

    &.active {
      background-image: url('/src/assets/static/icon/c_check-on.png');
    }
  }

  .box2 {
    width: 184px;
  }

  .box3 {
    width: 278px;
  }

  .default {
    width: 39px;
    height: 18px;
    line-height: 18px;
    border-radius: 4px;
    border: 0.5px solid #aad8fe;
    background: linear-gradient(117deg, #3d6cfe 0%, #4ac3fc 100%);
  }
}

.add_pop {
  .add {
    display: block;
    margin-left: 7px;
    width: 22.5px;
    height: 26px;
    background: url('/src/assets/static/icon/c_address.png') no-repeat center;
    background-size: 100%;
  }

  .form_box .input.code {
    width: 380px;
  }
}</style>
